import { Component, ViewEncapsulation } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
@Component({
  selector: 'spinner-component',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  template: `
    <div
      *ngIf="spinnerService.httpLoading"
      class="opacity-50 absolute top-0 bottom-0 right-0 left-0"
      style="z-index: 20000"
    >
      <div class="flex h-full w-full">
        <div class="flex-grow bg-gray-400 flex items-center justify-center">
          <p-progressSpinner></p-progressSpinner>
        </div>
      </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class SpinnerComponent {
  constructor(public spinnerService: SpinnerService) {}
}
